import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
import { AgencyModal } from './AgencyModal';
export const CTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-370" data-mp="1uhpxatqu22x3">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-371" data-mp="1uirab3reszhg" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372" data-mp="16rluuppds97o">
        <div className="bg-zano-charcoal rounded-3xl p-10 md:p-16 text-center text-white relative overflow-hidden" data-id="element-373" data-mp="16psl31jh18vg">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-374" data-mp="1ghokqh17h71s"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-zano-pink/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-375" data-mp="1bq6vgq8jouwn"></div>

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-376" data-mp="nzkluuiw72kj">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-377" data-mp="j1j7gmwevrfe">
              Access the elite layer of talent representation
            </h2>
            <p className="text-lg text-gray-300 mb-10" data-id="element-378" data-mp="33ck9tci631m2">
              Brand, marketing agency, or talent team — join the discovery layer
              for represented creators.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-379" data-mp="3d6at82zfsluw">
              <Button variant="secondary" className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" onClick={() => setIsModalOpen(true)} data-id="element-380" data-mp="3h7w27d8uofzt">
                List Your Agency
              </Button>
              <Link to="/pricing" data-id="element-381" data-mp="2yfaddcwd1poq">
                <Button variant="primary" className="bg-white text-zano-charcoal hover:bg-gray-100 w-full sm:w-auto px-8 py-3" data-id="element-382" data-mp="2ygd15bydzc0f">
                  Start Free Trial
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-383" data-mp="29roc63ad9jkn">
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-384" data-mp="25qmc5k8ml3hm">
                <h3 className="font-semibold text-white mb-2" data-id="element-385" data-mp="2jqdhyxozndkj">Brands</h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-386" data-mp="2joawmqys68m5">
                  Source represented talent and connect with managers directly.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-387" data-mp="1r2rhvzeyyr2f">
                  Learn more <ChevronRight size={16} data-id="element-388" data-mp="20s1arhhn0drl" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-389" data-mp="1w0t24no4swfh">
                <h3 className="font-semibold text-white mb-2" data-id="element-390" data-mp="18b8cjlxh30x8">
                  Marketing Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-391" data-mp="13cx5tk2h56j8">
                  Source fast and manage existing talent agency partners.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-392" data-mp="3exe7k5m5o9g5">
                  Learn more <ChevronRight size={16} data-id="element-393" data-mp="360dn2a27ivhz" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-394" data-mp="3a179t03wy49a">
                <h3 className="font-semibold text-white mb-2" data-id="element-395" data-mp="1lvwk1unw79n">
                  Talent Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-396" data-mp="6iw46h75ti2v">
                  Turn your roster into bookable, always-live public media kits.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-397" data-mp="3tnlp8j4c9ofs">
                  Learn more <ChevronRight size={16} data-id="element-398" data-mp="2i8yhm8f4vy2i" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};